module.exports = __webpack_public_path__ + "static/media/dropper.371b6b72.svg";